import {
    CountryWithPostalCodeAsAddressLookup,
    REVERSE_NAME_ORDER_COUNTRY_CODES,
} from "@lib/constants/addresses";
import type { TCountryCode } from "countries-list";

export const isCountryWithReverseNameOrder = (countryCode: TCountryCode) => {
    return REVERSE_NAME_ORDER_COUNTRY_CODES.includes(countryCode);
};

export const fieldKeyForAdrressLookup = (countryCode: string) => {
    return CountryWithPostalCodeAsAddressLookup.includes(countryCode) ? "postalCode" : "streetName";
};

export const usesPostalCodeLookup = (country: string): boolean => {
    return CountryWithPostalCodeAsAddressLookup.includes(country);
};

export const formatDateOfBirth = (date: string, country: string) => {
    const formatJP = () => {
        const [day, month] = date.split("/");

        return `${month}/${day}`;
    };

    const config = {
        JP: formatJP,
    };

    return config[country]?.() ?? date;
};

export const getDateFormat = (country: string) => {
    const config = {
        JP: "MM/DD",
    };

    return config[country];
};
